import Browser from '@mindful-web/marko-web/browser';
import Shared from '@randall-reilly/package-global/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';

Shared(Browser);
Leaders(Browser);

export default Browser;
